import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SettingsIcon from "@material-ui/icons/Settings";
import {
  CenterFocusWeak,
  CropFree,
  LocalHospital,
  PermMedia,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import { ContextGlobal } from "../../context";

const styles = (theme) => ({
  categoryHeader: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  categoryHeaderPrimary: {
    color: theme.palette.common.white,
  },
  item: {
    paddingTop: 1,
    paddingBottom: 1,
    color: "rgba(255, 255, 255, 0.7)",
    "&:hover,&:focus": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
  },
  itemCategory: {
    backgroundColor: "#232f3e",
    boxShadow: "0 -1px 0 #404854 inset",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  firebase: {
    fontSize: 24,
    color: theme.palette.common.white,
  },
  itemActiveItem: {
    color: "#4fc3f7",
  },
  itemPrimary: {
    fontSize: "inherit",
  },
  itemIcon: {
    minWidth: "auto",
    marginRight: theme.spacing(2),
  },
  itemIcon1: {
    minWidth: "auto",
    marginLeft: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
  },
});

function Navigator(props) {
  const { classes, ...other } = props;
  const { data } = useContext(ContextGlobal);
  const [navActiveLink, setNavActiveLink] = useState("Hospital Data");

  const categories = [
    {
      id: `Hi ${data.data.name},`,
      children: [
        data.data.type === "user"
          ? {
              id: "Hospital Data",
              icon: <LocalHospital />,
              path: "/dashboard/hospitalData",
            }
          : data.data.type === "doctor"
          ? {
              id: "Scanner",
              icon: <CenterFocusWeak />,
              path: "/dashboard/Scanner/reports",
            }
          : "",
        {
          id: "My Docs",
          icon: <PermMedia />,
          path: "/dashboard/myDocs/prescriptions",
        },
      ],
    },
    // {
    //   id: "Quality",
    //   children: [
    //     { id: "Analytics", icon: <SettingsIcon /> },
    //     { id: "Performance", icon: <TimerIcon /> },
    //     { id: "Test Lab", icon: <PhonelinkSetupIcon /> },
    //   ],
    // },
  ];

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>
        <ListItem
          className={clsx(classes.firebase, classes.item, classes.itemCategory)}
        >
          MedVault
        </ListItem>
        <ListItem
          className={clsx(classes.item, classes.itemCategory)}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Link
            to="/dashboard/profile/QRcode"
            style={{ color: "inherit", textDecoration: "none", flex: "1" }}
          >
            <ListItem
              style={{ padding: "0px" }}
              className={
                "QRcode" === navActiveLink ? " " + classes.itemActiveItem : ""
              }
              onClick={() => {
                setNavActiveLink("QRcode");
              }}
            >
              <ListItemIcon className={classes.itemIcon}>
                <CropFree />
              </ListItemIcon>
              <ListItemText
                classes={{
                  primary: classes.itemPrimary,
                }}
              >
                Profile
              </ListItemText>
            </ListItem>
          </Link>
          <ListItem
            style={{
              padding: "0px",
              display: "flex",
              justifyContent: "end",
              width: "max-content",
            }}
          >
            <Divider orientation="vertical" flexItem />
            <Link
              to="/dashboard/profile/settings"
              onClick={() => {
                setNavActiveLink("profile");
              }}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              <ListItemIcon
                className={
                  classes.itemIcon1 +
                  ("profile" === navActiveLink
                    ? " " + classes.itemActiveItem
                    : "")
                }
              >
                <SettingsIcon />
              </ListItemIcon>
            </Link>
          </ListItem>
        </ListItem>

        {categories.map(({ id, children }) => (
          <React.Fragment key={id}>
            <ListItem className={classes.categoryHeader}>
              <ListItemText
                classes={{
                  primary: classes.categoryHeaderPrimary,
                }}
              >
                {id}
              </ListItemText>
            </ListItem>
            {children.map(({ id: childId, icon, path }) => (
              <Link
                to={path}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                <ListItem
                  key={childId}
                  button
                  className={
                    classes.item +
                    (childId === navActiveLink
                      ? " " + classes.itemActiveItem
                      : "")
                  }
                  onClick={() => {
                    setNavActiveLink(childId);
                  }}
                >
                  <ListItemIcon className={classes.itemIcon}>
                    {icon}
                  </ListItemIcon>
                  <ListItemText
                    classes={{
                      primary: classes.itemPrimary,
                    }}
                  >
                    {childId}
                  </ListItemText>
                </ListItem>
              </Link>
            ))}

            <Divider className={classes.divider} />
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
}

Navigator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Navigator);
